import React, { useState, createContext } from 'react'
import './App.css'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import ReactGA from 'react-ga4'
import AppDetails from './components/details/AppDetails'
import HomePage from './components/home/HomePage'
import Header from './components/common/Header'
import GetInTouch from './components/contact/GetInTouch'
import { GA_MEASUREMENT_ID } from './constants/Constants'
import ErrorBoundary from './ErrorBoundary'
import NotFound from './views/NotFound'

export interface IAppContext {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  showSearch: boolean;
  setShowSearch: React.Dispatch<React.SetStateAction<boolean>>;
  currentApp: string;
  setCurrentApp: React.Dispatch<React.SetStateAction<string>>;
  searchInput: string;
  setSearchInput: React.Dispatch<React.SetStateAction<string>>;
}

export const AppContext = createContext<IAppContext>({
  searchTerm: '',
  setSearchTerm: () => {
    //
  },
  showSearch: false,
  setShowSearch: () => {
    //
  },
  currentApp: '',
  setCurrentApp: () => {
    //
  },
  searchInput: '',
  setSearchInput: () => {
    //
  }
})

function App () {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [showSearch, setShowSearch] = useState<boolean>(false)
  const [currentApp, setCurrentApp] = useState<string>('')
  const [searchInput, setSearchInput] = useState<string>('')

  const values = { searchTerm, setSearchTerm, showSearch, setShowSearch, currentApp, setCurrentApp, searchInput, setSearchInput }

  // Initialize GA
  if (window.location.href.indexOf('whatfix.com') > -1) {
    ReactGA.initialize(GA_MEASUREMENT_ID)
  }

  return (
    <AppContext.Provider value={values}>
    <Router>
      <Header />
      <ErrorBoundary>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="details" element={<AppDetails />}>
          <Route path=":appId" element={null}>
            <Route path=":appName" element={null} />
          </Route>
        </Route>
        <Route path="getInTouch" element={<GetInTouch />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
      </ErrorBoundary>
    </Router>
    </AppContext.Provider>
  )
}

export default App
